import { render, staticRenderFns } from "./maApproval.vue?vue&type=template&id=adb28c5c&scoped=true&"
import script from "./maApproval.vue?vue&type=script&lang=js&"
export * from "./maApproval.vue?vue&type=script&lang=js&"
import style0 from "./maApproval.vue?vue&type=style&index=0&id=adb28c5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb28c5c",
  null
  
)

export default component.exports